// First-run screen: shown when no daemons are paired yet. There's no project to
// scope to, so instead of an empty shell we point straight at pairing.
import { el, clear } from "../dom.js";
import { openScanner } from "./scanner.js";

export function renderWelcome(root: HTMLElement): void {
  clear(root);

  const pairBtn = el(
    "button",
    { class: "primary", onclick: () => openScanner((hash) => { location.hash = hash; }) },
    ["⧉ Pair a device"],
  );
  root.append(el("header", { class: "topbar" }, [el("h1", {}, ["Fabrika"]), pairBtn]));

  root.append(
    el("div", { class: "empty" }, [
      "No projects paired yet.",
      el("p", { class: "meta" }, ["Open Fabrika on your computer → Settings → Phone relay → Show pairing QR, then tap Pair above (or scan it with this phone's camera)."]),
    ]),
  );
}
